export const environment = {
  production: true,
  instrumentationKey: "",
  apiUrl: "https://ls-api-stage.azure.chevron.com",
    redirectUri: "https://ls-stage.azure.chevron.com",
     msalClientId: "454f948d-9bac-431e-9698-b48df0526189",
  msalAuthority: "https://login.microsoftonline.com/fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
  apiScope: "https://whc.azure.chevron.com/user_impersonation"
};
  
